module.exports = __webpack_public_path__ + "img/09.4d02895d.jpg";